import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import cuid from 'cuid';
import PropTypes from 'prop-types';
import translate from '@/lib/intl/translate';
import { ConstituentType } from '@/lib/types/ConstituentPropType';

const ALL = 'all';
const menuItems = [
  {
    value: ALL,
    label: translate('ALL_CONSTITUENTS'),
  },
  {
    value: ConstituentType.PRS,
    label: translate('CONSTITUENTS_NEW_CONSTITUENT_INDIVIDUAL_LABEL'),
  },
  {
    value: ConstituentType.ORG,
    label: translate('CONSTITUENTS_NEW_CONSTITUENT_ORG_LABEL'),
  },
];

function ConstituentTypeSelect({ className, id, onChange, value }) {
  const [uid] = React.useState(id || cuid());

  const handleChange = (e) => {
    const { target } = e;
    onChange({
      ...e,
      target: {
        ...target,
        value: target.value === ALL ? null : target.value,
      },
    });
  };

  const inputId = `constituent-type-select-${uid}`;

  return (
    <FormControl className={className} data-testid="constituent-type-select">
      <InputLabel
        className="whitespace-nowrap"
        htmlFor={inputId}
        id={`constituent-type-select-label-${uid}`}
      >
        {translate('CONSTITUENT_TYPE')}
      </InputLabel>
      <Select
        labelId={`constituent-type-select-label-${uid}`}
        id={inputId}
        value={value || ALL}
        className="w-full"
        name="constituentType"
        label={translate('CONSTITUENT_TYPE')}
        onChange={handleChange}
      >
        {menuItems.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

ConstituentTypeSelect.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

ConstituentTypeSelect.defaultProps = {
  className: '',
  id: null,
  onChange: () => {},
  value: null,
};

export default ConstituentTypeSelect;
